<template>
  <form @submit.prevent="handleSubmit" id="schedule_create_form">
    <!-- Schedule Date -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Schedule Date <span class="text-danger">*</span></label>
      <input type="date" class="form-control form-control-thin" id="date" name="date" ref="date"
        v-model="form.date" required />
    </div>

    <!-- Schedule Times -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Schedule Times <span class="text-danger">*</span></label>
      
      <!-- Time Inputs -->
      <div v-for="(time, index) in form.times" :key="index" class="time-input-group">
        <div class="input-group">
          <span class="input-group-text"><i class="fas fa-clock"></i></span>
          <input 
            type="time" 
            class="form-control form-control-thin" 
            v-model="form.times[index]" 
            name="times[]"
            required
          />
          <button 
            type="button" 
            class="btn btn-outline-danger btn-sm" 
            @click="removeTime(index)"
            :disabled="form.times.length === 1"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Add Time Button -->
      <button type="button" class="btn btn-sm btn-outline-primary mt-2" @click="addTime">
        <i class="fas fa-plus"></i> Add Time
      </button>
      <small class="text-muted d-block mt-1">Click to add multiple time slots</small>
    </div>

    <!-- Description -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Description If Any</label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Schedule Description" rows="2"></textarea>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger btn-sm hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn">
        <i class="fa fa-save"></i> Create Schedule
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'CreateSchedule',
  emits: ['created', 'close'],
  data() {
    return {
      form: {
        date: '',
        times: [''], // Start with one empty time slot
        description: ''
      },
      submitting: false
    }
  },
  methods: {
    addTime() {
      this.form.times.push('')
    },
    
    removeTime(index) {
      if (this.form.times.length > 1) {
        this.form.times.splice(index, 1)
      }
    },
    
    async handleSubmit() {
      this.submitting = true

      // Filter out empty times
      const times = this.form.times.filter(t => t !== '')
      if (times.length === 0) {
        this.$toast('Please add at least one time', false)
        this.submitting = false
        return
      }

      const result = await form_api_submit({
        url: 'wo/schedule/create/' + this.$route.params.id,
        method: 'POST',
        data: {
          date: this.form.date,
          times: times,
          description: this.form.description
        },
        curr_form_id: '#schedule_create_form',
      })

      if (result.success) {
        this.$emit('created')
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },

    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        date: '',
        times: [''],
        description: ''
      }
    }
  }
}
</script>

<style scoped>
.time-input-group {
  margin-bottom: 8px;
}

.time-input-group:last-of-type {
  margin-bottom: 0;
}

.input-group-text {
  background-color: #f8f9fa;
  color: #6c757d;
}

.btn-outline-danger {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-outline-primary {
  font-size: 12px;
}

/* Small screens */
@media (max-width: 576px) {
  .input-group {
    flex-wrap: nowrap;
  }
  
  .input-group .form-control {
    min-width: 0;
  }
}
</style>